import React, { FC } from 'react';
import { connect } from 'react-redux';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import { loadSingleBatch } from '@reducers/batch';
import { LoadSingleBatch } from '@interfaces/methods';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';
import JobContentWrapper from '@v2/pages/job/common/components/JobContentWrapper';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';
import { View } from 'react-native';

interface JobDetailsBatchDocumentsProps {
  loadSingleBatch: LoadSingleBatch;
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
}

const JobDetailsBatchDocumentsComponent: FC<JobDetailsBatchDocumentsProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
  loadSingleBatch,
  batch,
}) => {
  const title = useTitle();

  useJobDetails({
    operationsSearch,
    updateHeaderConfig,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
    loadSingleBatch,
  });

  const batchId = batch?.data?.productionBatchId;

  return (
    <JobContentWrapper loading={false} title={title.batch}>
      {batchId != null && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={batchId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.Batch} />
        </View>
      )}
    </JobContentWrapper>
  );
};

const JobDetailsBatchDocuments = connect(({ batch: { batch } }) => ({ batch }), {
  operationsSearch,
  updateHeaderConfig,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
  loadSingleBatch,
})(JobDetailsBatchDocumentsComponent);

export { JobDetailsBatchDocuments };
